import React from "react";
import { User_WorkoutData } from "../api/types/types";
import { smartTrim } from "../config/functions";

interface WorkoutCardProps {
  imageUrl: string;
  title: string;
  // rating: number;
  // reviewCount: number;
  workoutCount?: number;
  description: any;
  users?: User_WorkoutData[];
  additionalUsersCount?: number;
}

const WorkoutCard: React.FC<WorkoutCardProps> = ({
  imageUrl,
  title,
  // rating,
  // reviewCount,
  workoutCount,
  description,
  users,
  additionalUsersCount,
}) => {
  console.log("🚀 ~ additionalUsersCount:", additionalUsersCount);
  return (
    <div className="bg-white rounded-3xl shadow-md h-full flex flex-col justify-between">
      <div className="p-3">
        <img
          src={imageUrl}
          alt={title}
          className="w-full lg:h-36 md:h-36 h-80 rounded-2xl object-cover"
        />
        <div className="mt-4">
          <h3 className="text-sm font-bold">{title}</h3>
          {/* <d/iv className="flex items-center text-xs text-gray-600 mt-1"> */}
          {/* <span className="text-yellow-500">★</span> */}
          {/* <span className="ml-1">{rating.toFixed(1)}</span> */}
          {/* <span className="ml-1">
              ({reviewCount.toLocaleString()} Reviews)
            </span> */}
          {/* </div> */}
          {/* {workoutCount && ( */}
            <p className="text-xs text-gray-500 mt-2">
              {workoutCount} exercise{workoutCount && workoutCount > 1 ? "s" : ""}
            </p>
          {/* )} */}
          <div className=" mt-1 text-sm">
            <div
              dangerouslySetInnerHTML={{
                __html: smartTrim(description, 50),
              }}
            />
          </div>
        </div>
      </div>

      {additionalUsersCount !== undefined &&
        additionalUsersCount !== 0 &&
        users &&
        users.length >= 1 && (
          <div className="flex items-center gap-1 border-t p-3">
            {users.slice(0, 3).map((user) => (
              <img
                key={user.id}
                src={user?.user?.profile_image || "/images/profile.jpg"}
                alt={`User ${user.id}`}
                className="w-9 h-9 rounded-full border-2 border-white object-cover shadow-sm"
              />
            ))}
            {/* users.length > 3 &&   */}
            {users.length > 3 && (
              <div className="w-9 h-9 shrink-0 rounded-full border-2 border-white  bg-gray-200 flex items-center justify-center text-xs text-gray-600">
                +{users.length - additionalUsersCount}
              </div>
            )}
          </div>
        )}
    </div>
  );
};

export default React.memo(WorkoutCard);
